export function withItineraryLockSession<T>(payload: T, sessionId: string): T & { sessionId: string } {
  return { ...payload, sessionId };
}
